<template>
    <div>
        <el-form label-position="left" label-width="70px">
            <el-form-item label="学生名">
                <el-select v-model="student_id" clearable placeholder="请选择学生姓名" filterable remote
                           :remote-method="handleSearchStudentName"
                           @change="handleChange()"
                           style="width: 200px">
                    <el-option
                            v-for="item in $parentInfo.students"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="团名">
                <el-input v-model="name" style="width: 200px" disabled></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button @click="handleAddTeam()" :loading="$parentInfo.Dialogs_AddNewTeam.button_loading">新增团</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "Dialogs_AddNewTeam",
        data() {
            return {
                loading: true,
                student_id :'',
                name:'',
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleAddTeam() {
                this.$parentInfo.Dialogs_AddNewTeam.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'store_new_team', {
                    'student_id':this.student_id,
                    'name': this.name,
                })
            },
            handleSearchStudentName(query){
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type':'studentKeyName',
                    'studentKeyName': query,
                })
            },
            handleChange(){
                this.name='';
                for(let i=0;i<this.$parentInfo.students.length;i++){
                    if(this.$parentInfo.students[i].id==this.student_id){
                        this.name=this.$parentInfo.students[i].name;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>